import {
    apiRequest,
    pencantumanGelarApprove,
    pencantumanGelarDetail,
    masterEducation,
    masterEducationGroup,
    ListJabatan,
} from "../../../../../services/adapters/kepegawaian/pencantumanGelarService"

class ApproveRepository {

    fetchApprove = async (query) => {
        return await apiRequest("post", pencantumanGelarApprove, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", pencantumanGelarDetail, {
            params: query
        }, true)
    }

    fetchEducation= async (query) => {
        return await apiRequest("get", masterEducation, {
            params: query
        }, true)
    }

    fetchEducationGroup= async (query) => {
        return await apiRequest("get", masterEducationGroup, {
            params: query
        }, true)
    }
    fetchListJabatan = async (query) => {
        return await apiRequest("get", ListJabatan, {
            params: query
        }, true)
    }
}

export default ApproveRepository